import { cn } from "@/lib/utils";
import { BadgeType } from "@/stores/slices/commonSlice";
import { FlameIcon } from "../fun-ui/icons";


type PriceBadgeProps = {
  label: string;
  badge: BadgeType;
  size?: 14 | 12;
  scale?: number;
  rounded?: boolean;
  strong?: boolean;
  /** tr-bl：右上角+左下角圆角（贴卡片右上）；tl-br：左上角+右下角圆角（贴卡片左上） */
  corner?: 'tr-bl' | 'tl-br';
  /** 与父级卡片圆角对齐（设计稿 px，乘 scale），用于 borderTopLeftRadius / borderTopRightRadius */
  alignCornerRadiusPx?: number;
  /**
   * 升级弹窗档位卡左上角折扣角标（设计稿 1100×760 基准，乘 scale）：
   * - `offset`：贴外缘，由外层 `left/top: -3` 配合 `padding: 6 10 4 6`
   * - `inset`：hover 或选中时 `left/top: 0`，`padding: 3 10 4 3`
   */
  upgradeTlMode?: 'offset' | 'inset';
}
export function PriceBadge({
  label,
  badge = 'none',
  size = 14,
  scale = 1,
  rounded = false,
  strong = false,
  corner = 'tr-bl',
  alignCornerRadiusPx,
  upgradeTlMode,
}: PriceBadgeProps) {
  if (!['normal', 'primary', 'hyper'].includes(badge)) {
    return <></>;
  }

  const upgradePadding =
    upgradeTlMode && corner === 'tl-br'
      ? upgradeTlMode === 'offset'
        ? {
          paddingTop: `${3 * scale}px`,
          paddingRight: `${10 * scale}px`,
          paddingBottom: `${1 * scale}px`,
          paddingLeft: `${10 * scale}px`,
        }
        : {
          paddingTop: `${0 * scale}px`,
          paddingRight: `${10 * scale}px`,
          paddingBottom: `${1 * scale}px`,
          paddingLeft: `${7 * scale}px`,
        }
      : null;

  return (
    <div className={cn(
      "flex flex-row items-center",
      size === 14 && "font-semibold",
      strong && "font-semibold",
      "bg-[linear-gradient(250deg,var(--tw-gradient-stops))]",
      badge === 'normal' && "from-[#D3D7F1] to-[#F1F2F3] from-30% to-90% text-muted-foreground/70",
      badge === 'primary' && "from-[#FF8E0C] to-[#FFD95E] from-25% to-100% text-primary-foreground",
      badge === 'hyper' && "from-[#FF0C25] to-[#FF7943] from-25% to-100% text-primary-foreground",
    )}
      style={{
        ...(corner === 'tl-br'
          ? {
            borderTopLeftRadius: `${(alignCornerRadiusPx ?? 6) * scale}px`,
            borderBottomRightRadius: `${6 * scale}px`,
          }
          : {
            borderBottomLeftRadius: `${6 * scale}px`,
            borderTopRightRadius: `${(alignCornerRadiusPx ?? 6) * scale}px`,
          }),
        ...(upgradePadding ?? {
          padding: `${4 * scale}px ${10 * scale}px`,
        }),
        fontSize: `${(size === 14 ? 14 : 12) * scale}px`,
        lineHeight: `${(size === 14 ? 24 : 16) * scale}px`,
        ...(
          rounded ? {
            borderRadius: `${6 * scale}px`,
          } : {}
        )
      }}
    >
      {
        badge === 'hyper' ? (
          <FlameIcon
            size={size + 2}
            className="mr-1 shrink-0"
          />
        ) : null
      }
      <span>{label}</span>
    </div>
  );
}
